import { createAsyncActionTypes } from '@mews/framework/redux';

export const CREATE_RESERVATION_GROUP_STARTED = 'CREATE_RESERVATION_GROUP_STARTED';
export const CREATE_RESERVATION_GROUP_SUCCEEDED = 'CREATE_RESERVATION_GROUP_SUCCEEDED';
export const CREATE_RESERVATION_GROUP_FAILED = 'CREATE_RESERVATION_GROUP_FAILED';

const FETCH_RESERVATION_GROUP = 'FETCH_RESERVATION_GROUP';
export const [FETCH_RESERVATION_GROUP_STARTED, FETCH_RESERVATION_GROUP_SUCCEEDED, FETCH_RESERVATION_GROUP_FAILED] =
    createAsyncActionTypes(FETCH_RESERVATION_GROUP);
